/* Strain Jams listening tracker. Shared by the Strain Jams page
   (lab-strain-jams.js) and the product-page player (le-pdp-audio).

   Every event goes three places:
     1. Shopify custom event (Shopify.analytics.publish) -> the "Strain Jams to
        GA4" custom pixel forwards it to GA4. GA4 lives in the pixel sandbox, so
        the theme has no gtag of its own.
     2. Clarity custom event, so recordings can be filtered to listeners.
     3. Our first-party endpoint (theme setting "Listening events endpoint"),
        batched and sent with sendBeacon. Skipped while the setting is blank or
        when the shopper has not allowed analytics.

   Contract with the dashboard: docs/strain-jams/TRACKING-SPEC.md. Event and
   field names here must match it. */
(function (w, d) {
  'use strict';
  if (w.LEJamsTrack) return;

  var cfg = w.LE_JAMS || {};
  var ENDPOINT = cfg.endpoint || '';
  var mq = w.matchMedia ? w.matchMedia('(max-width: 767px)') : { matches: false };

  function makeId(key, store) {
    try {
      var v = store.getItem(key);
      if (!v) {
        v = (w.crypto && w.crypto.randomUUID) ? w.crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2);
        store.setItem(key, v);
      }
      return v;
    } catch (e) { return 'na'; }
  }
  var lid = makeId('le_jid', w.localStorage);
  var sid = makeId('le_jsid', w.sessionStorage);

  var refHost = '';
  try { refHost = d.referrer ? new URL(d.referrer).hostname : ''; } catch (e) {}
  var base = { src: cfg.src || 'jams_page', cust: cfg.cust ? 1 : 0, ref: refHost };

  function analyticsAllowed() {
    try {
      var cp = w.Shopify && w.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') return !!cp.analyticsProcessingAllowed();
    } catch (e) {}
    return true;
  }

  var queue = [];
  function flush() {
    if (!queue.length || !ENDPOINT) return;
    var body = JSON.stringify({ v: 1, events: queue.splice(0, 50) });
    var sent = false;
    try { sent = navigator.sendBeacon(ENDPOINT, new Blob([body], { type: 'text/plain' })); } catch (e) {}
    if (!sent) {
      try { fetch(ENDPOINT, { method: 'POST', body: body, keepalive: true, mode: 'no-cors', headers: { 'content-type': 'text/plain' } }); } catch (e) {}
    }
    if (queue.length) flush();
  }

  function track(name, props, opts) {
    var ev = { e: name, ts: Date.now(), lid: lid, sid: sid, src: base.src, dev: mq.matches ? 'mobile' : 'desktop', cust: base.cust, ref: base.ref };
    if (props) for (var k in props) if (Object.prototype.hasOwnProperty.call(props, k)) ev[k] = props[k];
    try { if (w.Shopify && w.Shopify.analytics && typeof w.Shopify.analytics.publish === 'function') w.Shopify.analytics.publish(name, ev); } catch (e) {}
    try { if (typeof w.clarity === 'function') w.clarity('event', name); } catch (e) {}
    if (ENDPOINT && analyticsAllowed()) {
      queue.push(ev);
      if ((opts && opts.flush) || queue.length >= 20) flush();
    }
  }

  function songProps(s) {
    return { song: s.h, title: s.t, genre: s.g || '', dur: Math.round(s.d || 0) };
  }
  function merge(a, b) { var o = {}, k; for (k in a) o[k] = a[k]; if (b) for (k in b) o[k] = b[k]; return o; }

  /* ---- "heard" list: feeds sales attribution through a cart attribute ---- */
  var HEARD_KEY = 'le_jams_heard';
  var WEEK = 7 * 864e5;
  function heard() {
    try {
      var list = JSON.parse(w.localStorage.getItem(HEARD_KEY) || '[]');
      var now = Date.now();
      return list.filter(function (x) { return x && x.h && now - x.t < WEEK; });
    } catch (e) { return []; }
  }
  var lastAttr = '';
  function rememberHeard(handle) {
    var list = heard().filter(function (x) { return x.h !== handle; });
    list.unshift({ h: handle, t: Date.now() });
    list = list.slice(0, 5);
    try { w.localStorage.setItem(HEARD_KEY, JSON.stringify(list)); } catch (e) {}
    var attr = list.map(function (x) { return x.h + '@' + new Date(x.t).toISOString().slice(0, 16); }).join(',');
    if (attr === lastAttr) return;
    lastAttr = attr;
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ attributes: { _jams_heard: attr } })
      }).catch(function () {});
    } catch (e) {}
  }

  /* ---- one listen = one jam_play ... one jam_listen ---- */
  var L = { song: null };
  function listenStart(song, extra) {
    if (L.song) listenEnd('switch');
    L = { song: song, listened: 0, last: null, max: 0, q: {} };
    track('jam_play', merge(songProps(song), extra));
    rememberHeard(song.h);
  }
  function listenTick(cur, dur) {
    if (!L.song) return;
    if (L.last !== null) {
      var dt = cur - L.last;
      if (dt > 0 && dt < 2.5) L.listened += dt;
    }
    L.last = cur;
    var pct = dur ? (cur / dur) * 100 : 0;
    if (pct > L.max) L.max = pct;
    [25, 50, 75].forEach(function (p) {
      if (pct >= p && !L.q[p]) { L.q[p] = 1; track('jam_progress', merge(songProps(L.song), { pct: p })); }
    });
  }
  function listenGap() { L.last = null; }
  function listenEnd(reason) {
    if (!L.song) return;
    var done = reason === 'complete' || L.max >= 95;
    track('jam_listen', merge(songProps(L.song), {
      listened: Math.round(L.listened),
      max_pct: Math.round(L.max),
      completed: done ? 1 : 0,
      end: reason
    }), { flush: true });
    L = { song: null };
  }
  function current() { return L.song; }

  /* On a product page: an add to cart of a product whose song was heard. */
  function watchAddToCart(handle) {
    d.addEventListener('cart:update', function (e) {
      var hit = heard().filter(function (x) { return x.h === handle; })[0];
      if (!hit) return;
      var detail = (e && e.detail) || {};
      track('jam_add_to_cart', { song: handle, variant: String(detail.variantId || detail.id || ''), value: Number(detail.value || 0) }, { flush: true });
    });
  }

  w.addEventListener('pagehide', function () { listenEnd('pagehide'); flush(); });
  d.addEventListener('visibilitychange', function () { if (d.visibilityState === 'hidden') flush(); });
  setInterval(flush, 30000);

  w.LEJamsTrack = {
    track: track,
    flush: flush,
    songProps: songProps,
    listenStart: listenStart,
    listenTick: listenTick,
    listenGap: listenGap,
    listenEnd: listenEnd,
    current: current,
    watchAddToCart: watchAddToCart,
    heard: heard
  };
})(window, document);
